import type { IconComponent } from '@consta/icons/Icon'
import { isButtonOfType } from '@library/constants'
import { isSubpath } from '@library/model'
import cn from 'classnames'
import type { FC, MouseEventHandler } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import css from './NavigationItem.css'

type NavigationItemProps = {
  label: string
  icon: IconComponent
  href: string
  onSelect?: VoidFunction
}

export const NavigationItem: FC<NavigationItemProps> = ({ icon: Icon, label, href, onSelect }) => {
  const { pathname } = useLocation()
  const isActive = isSubpath(href, pathname)
  const navigate = useNavigate()

  const handleSelect: MouseEventHandler = e => {
    if (isButtonOfType.Middle(e) || (isButtonOfType.Left(e) && e.ctrlKey)) {
      onSelect?.()
      return
    }

    e.preventDefault()
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Не во всех браузерах есть
    if (!document.startViewTransition) {
      onSelect?.()
      navigate(href)

      return
    }

    document
      .startViewTransition(() => {
        onSelect?.()
      })
      .finished.then(() => {
        navigate(href)
      })
  }

  return (
    <a
      className={cn(css.navigationItem, { [css.active]: isActive })}
      href={href}
      onClick={handleSelect}>
      <Icon size="s" />
      {label}
    </a>
  )
}
